import { render, staticRenderFns } from "./lossAnalysis.vue?vue&type=template&id=b6753710&scoped=true"
import script from "./lossAnalysis.vue?vue&type=script&lang=js"
export * from "./lossAnalysis.vue?vue&type=script&lang=js"
import style0 from "./lossAnalysis.vue?vue&type=style&index=0&id=b6753710&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6753710",
  null
  
)

export default component.exports